import { NotFound } from '@atlassian/mpac-primitives';
import Telemetry from '@atlassian/mpac-telemetry';
import React, { useLayoutEffect } from 'react';
import { productInfoMap } from './constants';
import { ProductHomepageView } from './ProductHomepageView';
export const ProductHomepage = _ref => {
  let {
    productId
  } = _ref;
  const productInfo = productInfoMap[productId];
  useLayoutEffect(() => {
    Telemetry.timeToFirstMeaningfulPaint(performance.now());
  }, []);
  if (!productInfo) {
    return /*#__PURE__*/React.createElement(NotFound, null);
  }
  return /*#__PURE__*/React.createElement(ProductHomepageView, {
    productInfo: productInfo,
    productId: productId
  });
};